import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type UserTemplateKanbanBoardCardView = {
    heading: Array<Uuid>;
    details: Array<
        Array<
            {
                iconId: Uuid;
                label: string;
            } & (
                | {
                      type: "SingleColumn";
                      dataSource: Uuid;
                  }
                | {
                      type: "MultipleColumn";
                      seperator: string;
                      dataSource: Array<Uuid>;
                  }
            )
        >
    >;
};

export type UserTemplateConfiguration = {
    /** Selects the assignment field used by geography UACM. Other geography fields are independent. */
    uacmGeographyColumnId?: Uuid;
    kanbanBoardCardView?: UserTemplateKanbanBoardCardView;
    organizationalUnitColumnId: Uuid | null;
    organizationalUnitTemplateId: Uuid | null;
};

const userTemplateKanbanBoardCardViewValidator: zod.ZodType<UserTemplateKanbanBoardCardView> = zod.strictObject({
    heading: uuidZodValidator.array(),
    details: zod.array(
        zod.array(
            zod.discriminatedUnion("type", [
                zod.strictObject({
                    iconId: uuidZodValidator,
                    label: zod.string(),
                    type: zod.literal("SingleColumn"),
                    dataSource: uuidZodValidator,
                }),
                zod.strictObject({
                    iconId: uuidZodValidator,
                    label: zod.string(),
                    type: zod.literal("MultipleColumn"),
                    seperator: zod.string(),
                    dataSource: uuidZodValidator.array(),
                }),
            ]),
        ),
    ),
});

export const userTemplateConfigurationValidator: zod.ZodType<UserTemplateConfiguration> = zod.strictObject({
    uacmGeographyColumnId: uuidZodValidator.optional(),
    kanbanBoardCardView: userTemplateKanbanBoardCardViewValidator.optional(),
    organizationalUnitColumnId: uuidZodValidator.nullable(),
    organizationalUnitTemplateId: uuidZodValidator.nullable(),
});
